export const getKeyByValue = (dictionary, value) => {
  return Object.keys(dictionary).find((key) => dictionary[key] === value);
};
